import styled, { css } from 'styled-components';

import { AvatarContainer, avatarSizeUnitMap } from '../Avatar';

import { AvatarListProps } from './types';

export const AvatarListContainer = styled.div<AvatarListProps>`
  display: flex;
  align-items: center;

  & > *:not(:first-of-type) {
    z-index: 2;
    margin-left: -${({ theme, size }) => theme.mosaiq.spacing(size === 'micro' || size === 'nano' ? 0.5 : 1)}px;
  }

  ${AvatarContainer} {
    border: 1px solid ${({ theme }) => theme.mosaiq.colors.white};
    ${({ size = 'regular', theme }) =>
      css`
        min-width: calc(${theme.mosaiq.spacing(avatarSizeUnitMap[size])}px + 1px);
        min-height: calc(${theme.mosaiq.spacing(avatarSizeUnitMap[size])}px + 1px);
        max-width: calc(${theme.mosaiq.spacing(avatarSizeUnitMap[size])}px + 1px);
        max-height: calc(${theme.mosaiq.spacing(avatarSizeUnitMap[size])}px + 1px);
      `};
  }
`;
